import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Layout } from '../../components'
import { Spinner } from '@chakra-ui/react'

import { admin } from './admin'
import { controler } from './controler'
import { operational } from './operational'
import { clubManager } from './clubManager'
import { guest } from './guest'

const roleRoutes = {
  ROLE_ADMINISTRATOR: admin,
  ROLE_CONTROLER: controler,
  ROLE_OPERATIONAL: operational,
  ROLE_CLUB_MANAGER: clubManager,
  ROLE_GUEST: guest
}

const AppLayoutWrapper = () => (
  <Layout>
    <Suspense fallback={<Spinner />}>
      <Outlet />
    </Suspense>
  </Layout>
)

export const protectedRoutes = (role) => {
  return [
    {
      path: '/*',
      element: <AppLayoutWrapper />,
      children: roleRoutes[role]
    }
  ]
}
